import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.0601 1.75568L5.9998 11.28L0.939453 5.96052L2.02566 4.92484L5.9998 9.1025L13.9739 0.720001L15.0601 1.75568Z",
		fill: "white"
	})
});
export default SvgCheck;
